import React from "react";
import PropTypes from "prop-types";

import './FeatureArticleTextBlock.scss';

const FeatureArticleTextBlock= ({
    title, text, children
}) => {

    return (
        (text || children) ? <div className="feature-article-text-block">
            <div className="feature-article-text-block__content">
                {title && <h2>{title}</h2>}
                {children ? 
                    <div className="feature-article-text-block__text">
                        {children}
                    </div> :
                    text ? <div className="feature-article-text-block__text" dangerouslySetInnerHTML={{ __html: text }} /> : null
                }
            </div>          
        </div> : null
    );
};

FeatureArticleTextBlock.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string
};

export default FeatureArticleTextBlock;



// WEBPACK FOOTER //
// ./src/components/FeatureArticleTextBlock/FeatureArticleTextBlock.jsx